import api, { Notifiable } from './api';
import { moduloOrcado, moduloProjeto, moduloRelatorioProjeto } from '../helpers/modulos';
import { InformacaoProjetoResult } from './tabelaProjetoOverView';

export interface Projeto {
  id: string;
  codigo: string;
  nome: string;
  numero: string;
  dataConclusao?: string;
  dataInicioBaseLine?: string;
  dataTerminoBaseLine?: string;
  escopoPluriAnual: string;
  requisitoAmbiental: string;
  plurianual?: boolean;
  valorOrcadoCapexTotal: number;
  valorOrcadoRFATotal: number;
  valorOrcadoEconomicoAnoTotal: number;
  valorOrcadoFinanceiroAnoTotal: number;
  situacao: string;
  responsavelMatricula: string;
  responsavelCentroDeCusto: string;
  dataHoraCadastroTotvs?: string;
  ultimaAtualizacaoDataHora?: string;
  ultimaAtualizacaoMatriculaResponsavel?: string;
  departamentoId?: string;
  areaId?: string;
  diretoriaId?: string;
  usuarioLiderProjetoId?: string;
  acronimoProjetoId?: string;
  statusProjetoId?: string;
  statusRfaId?: string;
  tipoProjetoFaseId?: string;
  statusNome?: string;

  dataConclusaoFormatada: string;
  dataInicioBaseLineFormatada: string;
  dataTerminoBaseLineFormatada: string;
  dataHoraCadastroTotvsFormatada: string;
  ultimaAtualizacaoDataHoraFormatada: string;

  responsavelMatriculaNome: string;
  ultimaAtualizacaoMatriculaResponsavelNome: string;
  texto_revisao: string;

  inicioBaselineDateTime?: Date;
  fimBaselineDateTime?: Date;

  inicioRealForcastDateTime?: Date;
  terminoRealForcastDateTime?: Date;

  inicioRealDateTime?: Date;
  terminoRealDateTime?: Date;

  informacaoProjetoResult?: InformacaoProjetoResult;

  projetoDisciplinaId?: string;
}

export interface ProjetoJoinCicloOrcamentario {
  id: string;
  nome: string;
  codigo: string;
  numero: string;
  index: number;
}

export interface PlanilhaCapex {
  revisao: string;
  dataAprovacao: Date;
  numero: number;
  projetoId: string;
  possuiPlanilhaCapex: boolean;
  numero_planilha: string;
  texto_revisao: string;
}

export interface TapCicloOrcamentarioHasJoinProjeto {
  tap_id: string;
  tap_areaId: string;
  tap_departamentoId: string;
  tap_diretoriaId: string;
  tap_escopoAnual: string;
  nomeArea: string;
  nomeDepartamento: string;
  nomeDiretoria: string;
  tap_id_Finplan: number;
  tap_ano: number;
}

export interface ProjetoOrdemInvestimento {
  projetoId: string;
  ordemInvestimentoId: string;
  codigo: string;
  codigoPacote: string;
  numero: string;
  nome: string;
}

export const getAllProjetoOrdemInvestimento = (projeto: string = '', pacoteOi: string = '') =>
  api.get<ProjetoOrdemInvestimento[]>(
    `projetos/getAllProjetoOrdemInvestimento?projeto=${projeto}&pacoteOi=${pacoteOi}`,
  );

export interface ProjetoPacote {
  CodigoPacote: string;
  PacoteOiNome: string;
  PacoteOiCodigo: string;
  pacoteOi: string;
  situacao: string;
  ultimaAtualizacao: string;
  possuiRfa: string;
  projetoNome: string;
  matriculaResponsavel: string;
  acronimoId: string;
  projetoId: string;
  ordemId: string;
  index: number;
}

export interface RequisitadoRc {
  codigoPacote: string;
  nome: string;
  numero: string;
  rcStatus: string;
  valorTotalFormatado: string;
  requisicaoCompraValorTotalFormatado: string;
  ordemInvestimentoId: string;
  index: number;
  requisitadoComOrdemDeCompra: RequisitadoComOrdemCompra[];
  requisitadoSemOndemDeCompra: RequisitadoSemOrdemCompra[];
}

export interface RequisitadoSemOrdemCompra {
  narrativa: string;
  requisicaoCompraNumero: number;
  requisicaoCompraSeq: number;
  requisicaoCompraValorTotal: string;
  requisicaoCompraValorTotalFormatado: string;
  valorParaDistribuidoFormatado: string;
  valorDistribuidoFormatado: string;
  distribuidoTotalFormatado: string;
  ordemInvestimentoId: string;
  principalFormatado: string;
  index: number;
}

export interface RequisitadoComOrdemCompra {
  narrativa: string;
  requisicaoCompraNumero: number;
  requisicaoCompraSeq: number;
  requisicaoCompraValorTotal: string;
  requisicaoCompraValorTotalFormatado: string;
  valorParaDistribuidoFormatado: string;
  valorDistribuidoFormatado: string;
  distribuidoTotalFormatado: string;
  ordemInvestimentoId: string;
  principalFormatado: string;
  requisicaoCompraOc: string;
  index: number;
}

export interface ResumoContratado {
  codigoPacote: string;
  nome: string;
  numero: string;
  status: string;
  valorTotalFormatado: string;
  valorTotalTipoOverHeadFormatado: string;
  contratoCompraValorTotalFormatado: string;
  ordemInvestimentoId: string;
  index: number;
}

export interface ContratadoRequisicaoCompraMaterial {
  narrativa: string;
  contratadoCompraNumero: number;
  contratadoCompraSeq: number;
  requisicaoCompraValorTotal: string;
  requisicaoCompraValorTotalFormatado: string;
  valorParaDistribuidoFormatado: string;
  valorDistribuidoFormatado: string;
  distribuidoTotalFormatado: string;
  ordemInvestimentoId: string;
  principalFormatado: string;
  contratadoCompraOc: string;
  pedidoPcm: number;
  index: number;
}

export interface ContratadoRequisicaoCompraServico {
  narrativa: string;
  contratadoCompraNumero: number;
  contratadoCompraSeq: number;
  requisicaoCompraValorTotal: string;
  requisicaoCompraValorTotalFormatado: string;
  valorParaDistribuidoFormatado: string;
  valorDistribuidoFormatado: string;
  distribuidoTotalFormatado: string;
  ordemInvestimentoId: string;
  principalFormatado: string;
  contratadoCompraOc: string;
  pedidoPcm: number;
  pedidoCtPcs: number;
  index: number;
}

export interface ContratadoOverHeadAnual {
  resultDataTabel: ContratadoOverHead[];
  anos: number[];
}

export interface ContratadoOverHead {
  codigoAgrupador: string;
  codigoContaContabil: string;
  codigoProjeto: string;
  crfContaContabilCcId: string;
  moduloEconomicoContratadoId: string;
  nome: string;
  numeroProjeto: string;
  valorCrfContratadoAnoOverHead: string;
  valorCrfContratadoAnoOverHeadFormatado: string;
}

export interface RequisitadoAno {
  pcmId: string;
  requisicaoCompraSeqId: string;
  ordemInvestimentoId: string;
  ordemInvestimentoRequisicaoCompraSeqId: string;
  moduloEconomicoContratadoId: string;
  ordemCompraId: string;

  ordemInvestimentoRequisicaoCompraSeqPrincial: boolean;

  pacoteProjeto: string;
  pacotePctOi: string;

  requisicaoCompraNumero: number;
  requisicaoCompraSeq: string;
  requisicaoCompraPrecoUnitarioFormatado: string;
  requisicaoCompraPrecoUnitario: number;
  requisicaoCompraQuantidadeTotal: string;
  requisicaoCompraValorTotal: number;
  requisicaoCompraValorTotalFormatado: string;
  requisicaoCompraOc: string;

  pedidoPcm: string;
  pedidoCtPcs: string;
  pedidoCtPreUnitarioFormatado: string;
  valorUnitarioPedido: number;

  valorFormatado: string;
  quantidadeFormatado: string;
  numero: string;
}

export interface ProjetoOrdemInvestimentoPlurianualTotalizador extends Notifiable {
  ordemInvestimento: ProjetoOrdemInvestimentoPlurianual[];
  totalColunaA: string;
  totalColunaB: string;
  totalColunaC: string;
  totalColunaD: string;
  totalColunaE: string;
  totalColunaF: string;
  totalColunaG: string;
  totalColunaH: string;
  totalColunaI: string;
  totalColunaVerificacaoPlaurianual: string;
  totalColunaJ: string;
  totalVerificacaoAnual: string;
  totalExecutadoNosAnosAnteriores: string;
}

export interface ProjetoOrdemInvestimentoPlurianual {
  numeroLinha: number
  id: string;
  codigoPacote: string;
  nomePacote: string;
  orcadoFormatado: string;
  contratadoFormatado: string;
  executadoFormatado: string;
  requisitadoFormatado: string;
  compromissadoFormatado: string;
  aContratarFormatado: string;
  forcastFormatado: string;
  saldoFormatado: string;
  editavel: boolean;

  orcado: number;
  contratado: number;
  executado: number;
  requisitado: number;
  compromissado: number;
  aContratar: number;
  forcast: number;
  saldo: number;
  aDistribuir: number;
  compromissadoAno: number;
  executadoAnosAnterios: number;
  verificacaoAnual: number;
  verificacaoPlurianual: number;

  ordemInvestimentoId: string
  pcmId: string
  contratoPcsId: string
  fornecedorId: string
  tipoConsolidadoPlurianualCodigo: number


  tipoDistribuicaoForcastId: string;
  tipoDistribuicaoForcastCodigo: number;
  consolidadoPlurianualId: string;
  periodoFim: string;
  periodoInicio: string;
  children: ProjetoOrdemInvestimentoPlurianual[];

  anoMesADistribuir: TotalToAno[];
  anoMes: TotalToAno[];
  existeValorDitribuido: boolean;
}
export interface TotalToAno {
  dataIndex: string;
  anoMes: string;
  totalColunaAnoMes: string;
}

export const getAllContratoOrdemInvestimentoPlurianualByProjetoId = (id: any, atualizarTabela: boolean) => {
  return api.get<ProjetoOrdemInvestimentoPlurianualTotalizador>(`projetos/getAllContratoOrdemInvestimentoPlurianualByProjetoId/${id}/${atualizarTabela}`);
}

export const getAllProjetos = () => api.get<Projeto[]>('projetos');
export const getAllProjetoRelatorios = () => api.get<Projeto[]>('projetos/getAllProjetoRelatorios');
export const getAllProjetoRelatorioRpp = () => api.get<Projeto[]>('projetos/getAllProjetoRelatorioRpp');

export const updateDadosProjeto = (projeto: Projeto) => {
  return api.put<Projeto>(`projetos/dadosprojeto/${projeto.id}`, projeto);
}
export const updateAcronimoProjeto = (projeto: Projeto) => api.put<Projeto>(`projetos/acronimo/${projeto.id}`, projeto);
export const updateResponsaveisProjeto = (projeto: Projeto) =>
  api.put<Projeto>(`projetos/responsaveis/${projeto.id}`, projeto);

export const getAllProjetoOptions = () =>
  getAllProjetos().then(projeto => (projeto || []).map(a => ({ text: a.nome, value: a.id.toString() })));

export const createPlanilhaOrcamento = (projetoId: string, file: any, planilhaCapex: PlanilhaCapex) => {
  const form = new FormData();
  planilhaCapex.projetoId = projetoId;

  if (planilhaCapex.texto_revisao == null) {
    planilhaCapex.texto_revisao = '';
  }

  if (planilhaCapex.numero_planilha == null) {
    planilhaCapex.numero_planilha = '';
  }

  form.append('file', file);
  form.append('projetoId', projetoId);
  form.append('numero', planilhaCapex.numero_planilha);
  form.append('revisao', planilhaCapex.texto_revisao);
  form.append('dataAprovacao', String(planilhaCapex.dataAprovacao));

  return api.post(`projetos/createPlanilhaCapexCommandHandler`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const createPlanilhaOrcamentoRfa = (projetoId: string, file: any, planilhaCapex: PlanilhaCapex) => {
  const form = new FormData();
  planilhaCapex.projetoId = projetoId;
  if (planilhaCapex.texto_revisao == null) {
    planilhaCapex.texto_revisao = '';
  }

  if (planilhaCapex.numero_planilha == null) {
    planilhaCapex.numero_planilha = '';
  }

  form.append('file', file);
  form.append('projetoId', projetoId);
  form.append('numero', planilhaCapex.numero_planilha);
  form.append('revisao', planilhaCapex.texto_revisao);
  form.append('dataAprovacao', String(planilhaCapex.dataAprovacao));

  return api.post(`projetos/createPlanilhaRfaCommandHandler`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export interface ProjetoJoinPacote {
  id: string;
}

export const getProjetoJoinTipoPacote = (join: ProjetoJoinPacote) =>
  api.get<ProjetoPacote[]>(`projetos/projetoJoinPacote/${join.id}`);

export const getAllRequisitoProjeto = (id: any) =>
  api.get<RequisitadoRc[]>(`requisitadoOc/requisitadoRcByProjetoId/${id}`);

export const getAllRequisitoSemOrdemCompraProjeto = (id: any) =>
  api.get<RequisitadoSemOrdemCompra[]>(`requisitadoOc/requisitadoCompraByProjetoId/${id}`);

export const getAllRequisitoComOrdemCompraProjeto = (id: any) =>
  api.get<RequisitadoComOrdemCompra[]>(`requisitadoOc/requisitadoComOrdemCompraByProjetoId/${id}`);

export const getAllResumoContratadoProjeto = (id: any) =>
  api.get<ResumoContratado[]>(`contratos/resumoContratadoByProjetoId/${id}`);

export const getAllContratadoMaterialProjetoByNumeroOi = (id: any) =>
  api.get<ContratadoRequisicaoCompraMaterial[]>(`contratadopcm/ContratoPcmCompraByProjetoId/${id}`);

export const getAllContratadoServicoProjetoByNumeroOi = (id: any) =>
  api.get<ContratadoRequisicaoCompraServico[]>(`contratopcs/ContratoServicoCompraByProjetoId/${id}`);

export const getAllContratadoTipoOverHeadByNumeroOi = (id: any) =>
  api.get<ContratadoOverHeadAnual>(`contratopcs/ContratadoTipoOverHeadByNumeroOi/${id}`);

export const atualizarValorContratadoAnoTipoOverHead = (
  moduloEconomicoContratadoId: any,
  ordemInvestimentoId: any,
  valorAlterado: string,
  ano: string,
) => {
  const form = new FormData();
  form.append('moduloEconomicoContratadoId', moduloEconomicoContratadoId);
  form.append('ordemInvestimentoId', ordemInvestimentoId);
  form.append('valorAlterado', valorAlterado);
  form.append('valorAlteradoDecimal', valorAlterado);
  form.append('ano', ano);
  form.append('anoTexto', ano);

  return api.post<any>(`contratopcs/atualizarValorContratadoAnoOverHead`, form);
};



export const getAllProjetosFiltroContexto = () => api.get<Projeto[]>('projetos');
export const getAllProjetosFiltroContextoTelaProjeto = () => api.get<Projeto[]>(`projetos/GetAllProjetosFiltroContexto/${moduloProjeto}`);
export const getAllProjetosFiltroContextoTelaRelatorioProjeto = () => api.get<Projeto[]>(`projetos/GetAllProjetosFiltroContexto/${moduloRelatorioProjeto}`);
export const getAllProjetosFiltroContextoPlanilhaCapex = () => api.get<Projeto[]>(`projetos/GetAllProjetosFiltroContexto/${moduloOrcado}`);